import React from 'react';

/**
 * SVG filters that key out the white background of the raster logo file.
 * Alpha is derived from luminance: white pixels become fully transparent,
 * black artwork becomes fully opaque and is recolored white or ink.
 */
export function LogoFilters() {
  return <svg aria-hidden="true" focusable="false" className="pointer-events-none absolute h-0 w-0 overflow-hidden" data-id="element-299" data-mp="nqwkzr9vtcgq">
      <defs data-id="element-300" data-mp="127r8lnhlvy">
        <filter id="hf-logo-white" colorInterpolationFilters="sRGB" data-id="element-301" data-mp="se9b1ecwli">
          <feColorMatrix type="matrix" values="0 0 0 0 1
                    0 0 0 0 1
                    0 0 0 0 1
                    -1 -1 -1 0 1" data-id="element-302" data-mp="3r7lhekfr35so" />
        </filter>
        <filter id="hf-logo-ink" colorInterpolationFilters="sRGB" data-id="element-303" data-mp="42xamhj8c7bu">
          <feColorMatrix type="matrix" values="0 0 0 0 0.043
                    0 0 0 0 0.055
                    0 0 0 0 0.066
                    -1 -1 -1 0 1" data-id="element-304" data-mp="41m4ib2banhk" />
        </filter>
      </defs>
    </svg>;
}